/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The runtime config of a PipelineSpec.
 * @export
 * @interface PipelineSpecRuntimeConfig
 */
export interface PipelineSpecRuntimeConfig {
  /**
   * The runtime parameters of the PipelineSpec. The parameters will be
   * used to replace the placeholders
   * at runtime.
   * @type {{ [key: string]: object; }}
   * @memberof PipelineSpecRuntimeConfig
   */
  parameters?: { [key: string]: object };
  /**
   *
   * @type {string}
   * @memberof PipelineSpecRuntimeConfig
   */
  pipeline_root?: string;
}

/**
 * Check if a given object implements the PipelineSpecRuntimeConfig interface.
 */
export function instanceOfPipelineSpecRuntimeConfig(
  value: object,
): value is PipelineSpecRuntimeConfig {
  return true;
}

export function PipelineSpecRuntimeConfigFromJSON(json: any): PipelineSpecRuntimeConfig {
  return PipelineSpecRuntimeConfigFromJSONTyped(json, false);
}

export function PipelineSpecRuntimeConfigFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PipelineSpecRuntimeConfig {
  if (json == null) {
    return json;
  }
  return {
    parameters: json['parameters'] == null ? undefined : json['parameters'],
    pipeline_root: json['pipeline_root'] == null ? undefined : json['pipeline_root'],
  };
}

export function PipelineSpecRuntimeConfigToJSON(json: any): PipelineSpecRuntimeConfig {
  return PipelineSpecRuntimeConfigToJSONTyped(json, false);
}

export function PipelineSpecRuntimeConfigToJSONTyped(
  value?: PipelineSpecRuntimeConfig | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    parameters: value['parameters'],
    pipeline_root: value['pipeline_root'],
  };
}
